import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Trophy, Medal } from "lucide-react";
import { cn } from "@/lib/utils";

const MEDAL = ["text-yellow-500", "text-zinc-400", "text-amber-700"];

export default function Leaderboard() {
  const { user } = useAuth();
  const { data: board = [], isLoading } = useQuery({ queryKey: ["leaderboard"], queryFn: () => api.get("/leaderboard").then((r) => r.data) });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading font-extrabold text-3xl flex items-center gap-2">
          <Trophy className="h-7 w-7 text-primary" /> Papan Skor
        </h1>
        <p className="text-muted-foreground mt-1">Peringkat gabungan skor eksperimen otomatis dan nilai PjBL.</p>
      </div>

      {isLoading && <p className="text-muted-foreground">Memuat…</p>}

      <Card className="rounded-md overflow-x-auto" data-testid="leaderboard-table">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-16">Peringkat</TableHead>
              <TableHead>Mahasiswa</TableHead>
              <TableHead>NIM</TableHead>
              <TableHead className="text-right">Eksperimen</TableHead>
              <TableHead className="text-right">PjBL</TableHead>
              <TableHead className="text-right">Total</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {board.map((b) => (
              <TableRow key={b.user_id} className={cn(b.user_id === user.id && "bg-accent/50")} data-testid={`rank-${b.rank}`}>
                <TableCell>
                  <div className="flex items-center gap-1.5 font-data font-semibold">
                    {b.rank <= 3 ? <Medal className={cn("h-4 w-4", MEDAL[b.rank - 1])} /> : <span className="w-4" />}
                    #{b.rank}
                  </div>
                </TableCell>
                <TableCell className="font-medium">{b.name}{b.user_id === user.id && <span className="text-xs text-primary ml-2">(Anda)</span>}</TableCell>
                <TableCell className="font-data text-sm text-muted-foreground">{b.nim || "–"}</TableCell>
                <TableCell className="text-right font-data">{b.experiment_score}</TableCell>
                <TableCell className="text-right font-data">{b.pjbl_score}</TableCell>
                <TableCell className="text-right font-data font-bold">{b.total}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {board.length === 0 && !isLoading && <p className="text-muted-foreground p-6 text-center">Belum ada data peringkat.</p>}
      </Card>
    </div>
  );
}
